import { Tag } from 'antd';
import css from './css.less';
import React from 'react';
const Tags = (props) => {
  const { children, ...rest } = props;
  return <Tag {...rest}>{children}</Tag>;
};
const CircleTags = (props) => {
  const { children, className, ...rest } = props;
  return (
    <Tag {...rest} className={`${css.circleTag} ${className}`}>
      {children}
    </Tag>
  );
};
export { CircleTags };
export default Tags;
